export default
    {
        catalogoEstudios: "/laboratorio/catalogoEstudios",
        guardaCotiza: "/laboratorio/guardaCotiza",
        listEstudios:"/laboratorio/listEstudios",
        listEstudioMini:"/laboratorio/listEstudioMini",

        listMedicos:"/laboratorio/listMedicos",
        guardaSolicitud:"/laboratorio/guardaSolicitud",

        listMedicosLab:"/laboratorio/listMedicosLab",
        guardaMedicosLab:"/laboratorio/guardaMedicosLab",
        imprimeReporteEstudios:"/laboratorio/imprimeReporteEstudios",
    }
